module.exports = "/React/dist/b03433c0e5f254a2e3b2a79bf9f51bbe.jpg";